<ng-container *ngIf="workbookBloc.workbookOrderStatus$ | async as workbookOrderStatus">
  <kui-modal
    *ngIf="showWorkbookModal && workbookOrderStatus.data?.dateOrdered != null"
    [isOpen]="showWorkbookModal && workbookOrderStatus.data?.dateOrdered != null"
    (isOpenChange)="showWorkbookModal = false"
    type="info">
    <kp-modal-workbook
      [timestamp]="workbookOrderStatus.data?.dateOrdered"
      (closeClicked)="showWorkbookModal = false"></kp-modal-workbook>
  </kui-modal>
</ng-container>

<div class="main-container">
  <div class="constellation-logo">
    <kp-reflect-animation [skipIntro]="true"></kp-reflect-animation>
  </div>
  <h1 class="heading" *ngIf="isMobile && verificationLink">You're eligible for {{ productName }}!</h1>
  <h1 class="heading" *ngIf="isMobile && !verificationLink">Welcome to {{ productName }}!</h1>
  <h1 class="heading" *ngIf="!isMobile">Take {{ productName }} wherever you go!</h1>
  <p class="directions mobile-directions" *ngIf="isMobile">
    To get started with the {{ productName }} app, follow the link below.
  </p>
  <p class="directions code-directions" *ngIf="!isMobile">
    <strong>Scan the code below</strong>
    to get started with the {{ productName }} app. Simply open your mobile device's camera and point it at the code.
  </p>
  <ng-container *ngIf="isPurposeful">
    <a
      [href]="appDeepLink"
      (click)="sendMobileDownloadedEvent()"
      class="button button-pill download-button"
      *ngIf="isMobile">
      Download the app
    </a>
    <div class="app-teaser" *ngIf="!isMobile">
      <img
        src="/assets/images/purposeful-phone-app-splash-night.png"
        alt="image of the loading screen of the Purposeful app on a mobile phone screen" />
      <div class="app-qr-link">
        <qr-code
          class="app-qr-code"
          [value]="appDeepLink"
          size="176"
          [margin]="0"
          [errorCorrectionLevel]="appDeepLink?.length > 75 ? 'L' : 'Q'"
          [attr.aria-label]="'Image of a custom QR code that links to the ' + productName + ' app'"
          role="img"
          *ngIf="validationStatus?.status !== status.starting; else qrLoading"></qr-code>
        <ng-template #qrLoading>
          <kp-shimmer class="qr-loading-shimmer"></kp-shimmer>
        </ng-template>
      </div>
    </div>
    <div class="separator"><span class="separator-copy">or</span></div>
  </ng-container>
  <div class="continue-web-container">
    <a
      class="button button-pill button-secondary button-continue-web"
      routerLink="/welcome/notice"
      (click)="sendContinueOnWebEvent()">
      Continue on the web
    </a>
  </div>
</div>
<!-- Using prettier ignore comment here to keep the period aligned with the end of the sentence without a space -->
<!-- prettier-ignore -->
<p class="support">
  If you have any questions or trouble getting started with {{ productName }}, contact us at
  <a href="mailto:support@kumanu.com" class="support-link" target="_blank">support@kumanu.com</a>.
</p>
